import React, { useEffect } from 'react'
import ReactGA from 'react-ga'
import Techstack from './Techstack'
import Toolstack from './Toolstack'
import Github from './Github'
import { FaGamepad, FaTv, FaPlane } from 'react-icons/fa'

function About() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [])

  return (
    <div style={{ paddingTop: '100px', background: 'var(--bg)', minHeight: '100vh' }}>
      <div className="section">
        <div className="section-inner">
          <div className="section-tag">about</div>
          <h1 className="section-title">Know Who <span>I Am</span></h1>

          <div className="about-grid">
            <div>
              <div className="about-card">
                <p className="about-text">
                  Hi Everyone, I am <b>Amaan Akbany</b> from <b>Gujarat, India</b>.
                  I am a Software Developer with a passion for AI/ML and cloud technologies.
                </p>
                <p className="about-text">
                  Apart from coding, some other activities that I love to do!
                </p>
                <ul className="about-hobbies">
                  <li><FaGamepad /> Playing Games</li>
                  <li><FaPlane /> Travelling</li>
                  <li><FaTv /> Watching Movies and Web Series</li>
                </ul>
                <div className="about-quote">
                  "The only way to learn a new programming language is by writing programs in it."
                  <footer>— Dennis Ritchie</footer>
                </div>
              </div>
            </div>

            <div>
              <div className="skills-section-title">Tech Stack</div>
              <Techstack />
              <div className="skills-section-title" style={{ marginTop: '24px' }}>Tools</div>
              <Toolstack />
            </div>
          </div>

          <div className="github-section">
            <Github />
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
